import "./Button.css";
import { ButtonProps } from "../../types/Button.types";

export const Button: React.FC<ButtonProps> = ({name, action, color = 'green', disabled = false, textSize = 13}) => {
    return (
        <button className={"add-button " + color + " " + (disabled ? "disabled" : "")} onClick={disabled ? () => {} : action} style={{fontSize: textSize}}>{name}</button>
    )
}